import { IconArrowRight } from "@tabler/icons-react";
import T from "prop-types";

const propTypes = {
  onClick: T.func,
  title: T.string,
  text: T.string,
};

function NavigationBox({ onClick, title, text }) {
  return (
    <div
      className="w-72 border border-solid border-grey-300 shadow rounded-lg p-4 hover:cursor-pointer hover:bg-primary-50"
      onClick={onClick}
    >
      <div className="flex flex-row gap-x-2">
        <div className="flex flex-col items-start">
          <div className="text-2xl text-grey-900 font-semibold first-letter:uppercase">
            {title}
          </div>
          <div className="text-sm text-grey-500 first-letter:uppercase">
            {text}
          </div>
        </div>
        <div className="flex flex-col items-start shrink-0">
          <IconArrowRight className="w-6 h-6 text-primary-700" />
        </div>
      </div>
    </div>
  );
}

NavigationBox.propTypes = propTypes;
export default NavigationBox;
